module.exports = __webpack_public_path__ + "static/media/tire-rotation-red.96685ead.svg";